export default __webpack_public_path__ + "static/media/02_motor_Promociones.46064ce6.svg";